import React, {FC, memo, useState} from "react";
import {Button, ButtonProps, Drawer, Skeleton, Tooltip} from "antd";
import {HistoryOutlined, SyncOutlined} from "@ant-design/icons";
import moment from "moment";
// import "moment/locale/de";
import {ApolloError} from "@apollo/client";
import {Booking, BookingHistoryByIdWithBookingInfoQuery, useBookingHistoryByIdWithBookingInfoQuery} from "../../generated/graphql";
import useHighestRole from "../../helpers/useHighestRole";
import Roles from "../../../shared/models/roles";
import BookingHistoryContent from "./BookingHistoryContent";
import css from "./BookingHistory.less";

type BookingHistoryDrawerProps = {
    bookingId?: Booking["id"];
    buttonProps?: ButtonProps;
    buttonStyle?: React.CSSProperties;
};

const BookingHistoryDrawer: FC<BookingHistoryDrawerProps> = ({bookingId, buttonProps, buttonStyle}) => {
    const highestRole = useHighestRole();
    const [open, setOpen] = useState(false);
    const [refetching, setRefetching] = useState(false);
    const {data, loading, error, refetch} = useBookingHistoryByIdWithBookingInfoQuery({
        skip: !bookingId || !open,
        variables: {bookingId: bookingId ?? ""},
        fetchPolicy: "network-only",
    });

    const history: BookingHistoryByIdWithBookingInfoQuery["bookingHistoryByIdWithBookingInfo"] = data?.bookingHistoryByIdWithBookingInfo ?? [];

    // console.log("history", history);
    const prefixedBookingNumber = history[0] ? `${history[0].bookingNumberPrefix}-${history[0]?.bookingNumber}` : "";

    // if (highestRole !== Roles.Superuser) {
    //     return null;
    // }

    if (!open) {
        return (
            <Tooltip title="Änderungshistorie der Buchung" placement="left">
                <Button {...buttonProps} onClick={() => setOpen(true)} icon={<HistoryOutlined style={{fontSize: buttonStyle?.fontSize}} />} style={buttonStyle} />
            </Tooltip>
        );
        // return (
        //     <Tooltip title="Änderungshistorie der Buchung (nur für Superuser sichtbar)">
        //         <Button {...buttonProps} onClick={() => setOpen(true)}>
        //             <HistoryOutlined />
        //         </Button>
        //     </Tooltip>
        // );
    }

    const LoadingContent = ({loading}: {loading: boolean}) => {
        if (!loading) {
            return null;
        }

        return (
            <div>
                <Skeleton active />
            </div>
        );
    };

    const ErrorContent = ({error}: {error?: Error}) => {
        if (!error) {
            return null;
        }

        return <div>{error.message}</div>;
    };

    const handleRefetch = async () => {
        setRefetching(true);
        await refetch();
        setRefetching(false);
    };

    const RefetchButton = () => {
        return <Button icon={<SyncOutlined spin={loading || refetching} />} type="link" onClick={handleRefetch} />;
    };

    return (
        <Drawer title={`Historie ${prefixedBookingNumber}`} open={open} onClose={() => setOpen(false)} destroyOnClose extra={<RefetchButton />} width="620px">
            <div>
                <LoadingContent loading={loading || refetching} />
                <ErrorContent error={error instanceof ApolloError ? error : undefined} />
                <BookingHistoryContent history={history} />
            </div>
        </Drawer>
    );
};

export default memo(BookingHistoryDrawer);
